export default class BrowserUtils {
    static isChrome() {
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }

    static isChromeiOS() {
        return navigator && navigator.userAgent && navigator.userAgent.match('CriOS');
    }

    static isSafari() {
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    }
}